
<div>
	<!-- <v-container align="center" justify="center" class="pa-5 pb-0">
		<ImageUploadAndCrop v-show="showCropper" :image="cropperImage" />
	</v-container> -->

	<v-container align="center" justify="center" class="pa-5 pb-0">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap"
					><h1>{{ getLabel('companyAboutSectionTitle', 'About the practice') }}</h1></v-list-item-title
				>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-container class="pt-0 mt-0 mb-0">
		<v-form ref="practiceAboutForm" v-model="valid" class="pl-4 pr-5 pt-0">
			<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
				<v-row class="justify-center text-center pb-0 pm-0">
					<v-col>
						<input v-show="false" ref="logo" type="file" hide-details :prepend-icon="false" @input="handleAvatarImage($event.target.files[0])" />
						<v-avatar v-ripple class="justify-center text-center" :size="150" style="margin: auto" color="#F4F4F4">
							<v-img :src="logoPreview" alt="" contain :max-width="150" class="mx-auto"></v-img>
						</v-avatar>
					</v-col>
				</v-row>

				<v-row cols="12" class="justify-center text-center"
					><v-col style="text-transform: none !important"
						><v-btn id="logo" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
							><v-icon class="pr-2" color="primary">backup</v-icon> upload your logo</v-btn
						></v-col
					></v-row
				>

				<v-row class="justify-center text-center">
					<v-col class="error--text">
						<v-card-text v-show="avatarError">Please upload an logo of your practice</v-card-text>
					</v-col>
				</v-row>

				<v-row>
					<v-col>
						<v-textarea
							outlined
							:value="short_bio"
							:rules="shortBioRules"
							:placeholder="getLabel('companyAboutSectionBioPlaceholder', 'Tell us more about your practice, your support team and your working environment.')"
							@change="changeBio"
						>
						</v-textarea>
					</v-col>
				</v-row>

				<v-row
					><v-col>
						<v-list-item-title align="center" justify="justify" class="pb-1 text-wrap"
							><h2>{{ getLabel('companyAboutSectionPicturesTitle', 'Upload pictures of your practice') }}</h2></v-list-item-title
						>
					</v-col></v-row
				>

				<v-row>
					<v-col :cols="12" :lg="4">
						<input v-show="false" ref="imageA" type="file" hide-details :prepend-icon="false" @change="handleImage($event.target.files[0])" />
						<v-btn id="imageA" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
							><v-icon class="pr-2" color="primary">backup</v-icon> upload image A</v-btn
						>
						<v-card outlined flat height="138px">
							<v-img :src="imageToShow('imageA')" contain alt="" height="135px" />
						</v-card>
					</v-col>

					<v-col :cols="12" :lg="4">
						<input v-show="false" ref="imageB" type="file" hide-details :prepend-icon="false" @change="handleImage($event.target.files[0])" />
						<v-btn id="imageB" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
							><v-icon class="pr-2" color="primary">backup</v-icon> upload image B</v-btn
						>
						<v-card outlined flat height="138px">
							<v-img :src="imageToShow('imageB')" contain alt="" height="135px" />
						</v-card>
					</v-col>

					<v-col :cols="12" :lg="4">
						<input v-show="false" ref="imageC" type="file" hide-details :prepend-icon="false" @change="handleImage($event.target.files[0])" />
						<v-btn id="imageC" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
							><v-icon class="pr-2" color="primary">backup</v-icon> upload image C</v-btn
						>
						<v-card outlined flat height="138px">
							<v-img :src="imageToShow('imageC')" contain alt="" height="135px" />
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-form>
	</v-container>
</div>
